import { Stack, Typography } from '@mui/material'
import { visuallyHidden } from '@mui/utils'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { COLORS, DividerWithLabel, ICONS, unit } from '@hcr/ui'

import { APP_CONFIG, HTTP_CONFIG, LINK_CONFIG } from '../../../../../configs'
import { useConsentSettings } from '../../../../../contexts'
import { Path } from '../../../../../models/navigation'
import { to } from '../../../../../utils/navigation'
import { Link } from '../link'

export const Settings: FC = () => {
  const { t } = useTranslation()
  const consentSettings = useConsentSettings()

  return (
    <Stack tabIndex={-1} component='li'>
      <DividerWithLabel component='h2'>{t('account.settings')}</DividerWithLabel>
      <Link onClick={consentSettings.open} title={t('about.change-consent-settings')} />
      <Link
        to={LINK_CONFIG.serviceTerms}
        key={t('about.service-terms')}
        target='_blank'
        rel='external'
        title={t('about.service-terms')}
        icon={ICONS.farArrowUpRightFromSquare}
      >
        <Typography sx={visuallyHidden}>{t('navigation.opens-in-a-new-tab')}</Typography>
      </Link>
      <Link
        title={t('about.privacy-policy')}
        to={LINK_CONFIG.privacyPolicy}
        key={t('about.privacy-policy')}
        target='_blank'
        rel='external'
        icon={ICONS.farArrowUpRightFromSquare}
      >
        <Typography sx={visuallyHidden}>{t('navigation.opens-in-a-new-tab')}</Typography>
      </Link>
      <Link
        to={LINK_CONFIG.accessibilityStatement}
        target='_blank'
        rel='external'
        title={t('about.accessibility-statement')}
        icon={ICONS.farArrowUpRightFromSquare}
      />
      <Stack gap={unit(1)} padding={`${unit(4)} ${unit(7)}`} borderBottom={`${unit(0.25)} solid ${COLORS.vaalea[600]}`}>
        <Typography component='dt' variant='labelM'>
          {t('about.version')}
        </Typography>
        <Typography component='dd' variant='bodyM'>
          {APP_CONFIG.version}
        </Typography>
      </Stack>
      <Link
        title={t('about.third-party-software-licenses')}
        to={APP_CONFIG.thirdPartySoftwareLicensesPath}
        target='_blank'
        rel='external'
        disableBorderBottom={!HTTP_CONFIG.API.Consumer.useMocks}
        icon={ICONS.farArrowUpRightFromSquare}
      >
        <Typography sx={visuallyHidden}>{t('navigation.opens-in-a-new-tab')}</Typography>
      </Link>
      {HTTP_CONFIG.API.Consumer.useMocks && (
        <Link to={to(Path.AboutMocks)} disableBorderBottom={true} title={t('about.change-mocked-data-settings')} />
      )}
    </Stack>
  )
}
